export default "__VITE_ASSET__BjpAtKCj__"